import { Chip, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useMaterialColor, useMaterials } from "hooks/useMaterials";
import { useMemo } from "react";

export const HeatPlannedMaterials = ({
  plannedMaterialNames,
}: {
  plannedMaterialNames: string[] | null;
}) => {
  const { t } = useTenantTranslation();
  const { materials } = useMaterials();
  const { getColor } = useMaterialColor();

  const plannedMaterials = useMemo(() => {
    const materialByName = new Map(
      (materials ?? []).map((material) => [material.name, material])
    );
    return (plannedMaterialNames ?? []).map((name) => {
      const material = materialByName.get(name);
      return {
        name,
        displayName: material?.labelling_name ?? name,
        color: getColor(name),
      };
    });
  }, [materials, plannedMaterialNames, getColor]);

  if (plannedMaterials.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("noPlannedRecipe")}
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      {plannedMaterials.map(({ name, displayName, color }) => (
        <Chip
          key={name}
          size="small"
          label={displayName.toUpperCase()}
          sx={{
            backgroundColor: `${color}40`,
            borderColor: color,
            borderWidth: 2,
            borderStyle: "solid",
            color: "text.primary",
          }}
        />
      ))}
    </Stack>
  );
};
